import { render, staticRenderFns } from "./EditorPage.htm?vue&type=template&id=713bebb0&scoped=true&"
import script from "./EditorPage.js?vue&type=script&lang=js&"
export * from "./EditorPage.js?vue&type=script&lang=js&"
import style0 from "./EditorPage.scss?vue&type=style&index=0&id=713bebb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713bebb0",
  null
  
)

export default component.exports